import Tito from "js/src/client/client.js";

export default function (params) {
  console.log("[Tito][development_mode]", "plugin loaded");
  tito("config.set", { developmentMode: true });
}
